import defaults from 'lodash-es/defaults';
import cloneDeep from 'lodash-es/cloneDeep';
import isEqual from 'lodash-es/isEqual';
import updateClass from './htmlEngine/css/updateClass';
import updateStyleByRef from './htmlEngine/css/updateStyleByRef';

const fadeControlsClass = [
  {
    selector: '&.fade-controls > .controls',
    properties: {
      opacity: '${controlsOpacity}!important',
      pointerEvents: 'none',
    },
  },
  {
    selector: '&.fade-controls > .io-controls',
    properties: {
      opacity: '${controlsOpacity}!important',
      pointerEvents: 'none',
    },
  },
];

const defaultOptions = {
  text: 'loading',
  color: '#FFFFFF',
  textColor: '#FFFFFF',
  maskColor: 'rgba(0, 0, 0, 0.7)',
  zlevel: 0,
  fontSize: 12,
  showSpinner: true,
  spinnerRadius: 10,
  lineWidth: 5,
  show: true,
  showDelay: 600,
  controlsOpacity: 0.1,
};

export default class Spinner {
  constructor(instance) {
    var me = this;
    me.instance = instance;
    // console.log('Spinner constructor');
    instance.on('beforereload', () => {
      // console.log('Spinner beforereload');
      if (!instance.options.spinner || instance.options.spinner.show) {
        me.show();
      }
    });

    instance.on('reload,reloadfailed', () => {
      if (!instance.options.spinner || instance.options.spinner.show) {
        me.hide();
      }
    });
  }

  show(options = {}) {
    var me = this;
    defaults(options, me.instance.options.spinner, defaultOptions);
    me.timer = setTimeout(() => {
      if(me.timer){
        me.updateFadeControlsClass(options);
        me.instance.args.element.classList.add('fade-controls');
        me.instance.chart.showLoading('default', options);        
      }
    }, options.showDelay);
  }

  hide() {
    if (this.timer) {
      clearTimeout(this.timer);
      delete this.timer;
    }

    this.instance.args.element.classList.remove('fade-controls');
    this.instance.chart.hideLoading();
  }

  updateFadeControlsClass(options) {
    let CSS = updateStyleByRef(cloneDeep(fadeControlsClass), {
      controlsOpacity: options.controlsOpacity,
    });

    if (isEqual(this.fadeControlsCSS, CSS)) {
      return;
    }

    this.fadeControlsCSS = CSS;
    this.fadeControlsSheet = updateClass(
      this.fadeControlsSheet || 'fade-controls-class-' + this.instance.id,
      CSS,
      '#' + this.instance.id
    );
  }
}
